export const appConfig = {
  sendGridApiKey: "",
  API: {
    URL: "https://api.mashaheeri.com",
    KEY: "4d721858-f7c8-4b6a-90e6-f6d11ec48b00",
  },
  /*
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },*/
};
